<template>
    <div class="mt-2">
        <div class="mr-4 ml-4 mt-4">
            <h2 v-translate>Example Page QR Code Scan</h2>
            <div class="text-unassigned" v-translate>This is an example of a page that you would normally see when the invoice is successfully issued.</div>
            <div class="text-unassigned" v-translate>The data displayed here is for demonstration purposes only and does not have any fiscal validity.</div>
            <div class="text-unassigned" v-translate>If something goes wrong when issuing the invoice, you may see an error message or "Factura no encontrada".</div>
        </div>

        <div style="display: flex; justify-content: center;" class="mt-4 pr-2 pl-2">
            <div class="border-success card" style="max-width: 616px;">
                <div class="card-header text-white bg-success">
                    <div class="row">
                        <div class="col-lg-2">
                            <svg class="svg-inline--fa fa-ico-aeat fa-w-16 ico-size-3 m-2" role="presentation" aria-hidden="true" focusable="false" data-prefix="aeat-ico" data-icon="ico-aeat" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 141 141" width="32px" height="32px" data-fa-i2svg=""><path fill="currentColor" d="M94.39,103.89C74.26,119.45,63.14,126,48.13,130.6,33.6,135,25.84,135.79,16,133c-2.06-3.36-4.21-7.1-6.26-10.59,8.42,1.46,21.29,1.07,36.37-4.87,16.09-6.78,22.17-10.17,34.8-19.72s30.2-24,41-39.29,11-20.64,9.83-30.51c3.73,6.1,6.3,10.49,7.58,13,.51,8.47-1.29,13.64-6,21.86C128.44,71.53,114.52,88.33,94.39,103.89ZM34.87,65.73l-7-12.09C10.94,70.62.69,89.36-.46,104.55l8.15,14C8.35,103.52,18.23,84.2,34.87,65.73Zm31,35.49c3.51-2.22,7.07-4.76,11.5-8.11a251.38,251.38,0,0,0,27.52-23.67L69.12,7.55H11.75ZM98,108.6c-7.59,5.87-14,10.48-19.73,14.22l6.82,11.81h57.37L117.57,91.48A211.08,211.08,0,0,1,98,108.6Z"></path></svg>
                        </div>
                        <div class="d-inline-flex align-items-center justify-content-center col-lg-8">
                            <svg class="svg-inline--fa fa-ico-confirmacion-sm fa-w-16 ico-size-3 m-2" role="presentation" aria-hidden="true" focusable="false" data-prefix="aeat-ico" data-icon="ico-confirmacion-sm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32px" height="32px" data-fa-i2svg=""><path fill="currentColor" d="M10,17.41,4.59,12,6,10.59l4,4,8-8L19.41,8ZM24,12A12,12,0,1,0,12,24,12,12,0,0,0,24,12Zm-2,0A10,10,0,1,1,12,2,10,10,0,0,1,22,12Z"></path></svg>
                            <h3 class="m-2">Factura encontrada</h3>
                        </div>
                    </div>
                </div>
                <div class="card-body text-justify">
                    <p class="card-text">En la Agencia Tributaria consta una factura con idénticas características a las remitidas:</p>
                    <div>
                        <div class="mb-3">
                            <strong class="text-info">NIF del expedidor: </strong>
                            <span class="notraducir">89890001K</span>
                        </div>
                        <div class="mb-3">
                            <strong class="text-info">Número de factura: </strong>
                            <span class="notraducir">12345678-G33</span>
                        </div>
                        <div class="mb-3">
                            <strong class="text-info">Fecha de expedición: </strong>
                            <span class="notraducir">01/01/2024</span>
                        </div>
                        <div class="mb-3">
                            <strong class="text-info">Importe: </strong>
                            <span class="notraducir">123,45 €</span>
                        </div>
                    </div>
                    <p class="card-text">El importe mostrado de la factura incluye el total de la contraprestación por los bienes o servicios facturados más, en su caso, el importe de los impuestos indirectos que la gravan, sin la consideración de otras cantidades, tales como gastos suplidos, retenciones a cuenta, recargos financieros, etc. que se consignen en la factura.</p>
                    <p class="card-text">Gracias por utilizar los servicios electrónicos de la Agencia Tributaria.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DraftQrCode"
}
</script>

<style scoped>
.card-body::before {
    content: 'TEST';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
    font-size: 100px;
    color: rgba(0, 136, 255, 0.356);
}
</style>